namespace RioERP.Reports {
    export interface OrderOutstandingReportForm {
        OrderId: Serenity.LookupEditor;
        OrderNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        NetAmount: Serenity.DecimalEditor;
        SourceType: Serenity.EnumEditor;
        Status: Serenity.EnumEditor;
        Recdamount: Serenity.DecimalEditor;
        OutstandingAmt: Serenity.DecimalEditor;
        OrderDate: Serenity.DateEditor;
    }

    export class OrderOutstandingReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderOutstandingReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderOutstandingReportForm.init)  {
                OrderOutstandingReportForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderOutstandingReportForm, [
                    'OrderId', w0,
                    'OrderNumber', w1,
                    'CustomerName', w1,
                    'CustomerEmail1', w1,
                    'CustomerMobile1', w1,
                    'NetAmount', w2,
                    'SourceType', w3,
                    'Status', w3,
                    'Recdamount', w2,
                    'OutstandingAmt', w2,
                    'OrderDate', w4
                ]);
            }
        }
    }
}
